'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"prod-card":"alloy-product-cards-module_prod-card__5MVoL","linkCard":"alloy-product-cards-module_linkCard__kONgs","basic":"alloy-product-cards-module_basic__t7usP","img":"alloy-product-cards-module_img__P7JBE","compact":"alloy-product-cards-module_compact__1Sxmr","price":"alloy-product-cards-module_price__IjMki","attribute":"alloy-product-cards-module_attribute__9-Omu","cursor-pointer":"alloy-product-cards-module_cursor-pointer__fTfqG"};

exports.default = styles;
//# sourceMappingURL=alloy-product-cards.module.scss.js.map
